import React from 'react';
import { Icon } from '@beisen/chaos-ui';
import DataBlockItem from './DataBlockItem';

require('./DataBlock.css');

class DataBlock extends React.Component {
	constructor(props) {
		super(props);
		this.handleToggleItem = this.handleToggleItem.bind(this);
		this.handleToggleIconClass = this.handleToggleIconClass.bind(this);
		this.isMultiple = props.cmp_data.multiple;
		this.screenWidth = window.screen.width * 0.85 - 16;

		this.state = {
			blockList: []
		};

		this.activeBlock = {
			texts: props.searchParams && props.searchParams.text || '',
			values: props.searchParams && props.searchParams.value || ''
		};
		this.isExpand = false;
		this.isRefresh = false;
	}

	componentWillReceiveProps(nextProps) {
		if((!nextProps.searchParams && this.activeBlock.values != '') || (nextProps.searchParams && (this.activeBlock.values != nextProps.searchParams.value))) {
			this.activeBlock.texts = nextProps.searchParams && nextProps.searchParams.text || '';
			this.activeBlock.values = nextProps.searchParams && nextProps.searchParams.value || '';
			this.isRefresh = true;
			this.setState({ blockList: this.getBlockList() });
		}
	}

	componentWillMount() {
		this.setState({ blockList: this.getBlockList() });
	}

	shouldComponentUpdate(nextProps, nextState) {
		if(this.isRefresh || !nextProps.searchParams && this.props.searchParams || (!nextProps.searchParams && !this.props.searchParams && (nextProps.searchParams != this.props.searchParams)) || (nextProps.searchParams && (nextProps.searchParams.value != this.activeBlock.values)) || this.state.blockList.length != nextState.blockList.length) {
			this.isRefresh = false;
			return true;
		}
		return false;
	}

	handleToggleIconClass(e) {
		e.preventDefault();
		if(e.target.className.includes('m-sys-arrowdown')) {
			e.target.className = 'icon-ex m-sys-arrowup icon';
		}else{
			e.target.className = 'icon-ex m-sys-arrowdown icon';
		}
		this.isExpand = !this.isExpand;
		!this.isExpand ? this.setState({ blockList: this.state.blockList.slice(0,this.count) }) : this.setState({ blockList: this.getBlockList() });
	}

    handleToggleItem(item) {
		let checkedValueArr = this.activeBlock.values === '' ? [] :  this.activeBlock.values.split(',');
		let checkedTextArr = this.activeBlock.texts === '' ? [] : this.activeBlock.texts.split(',');
		let activeIndex = checkedValueArr.indexOf(item['value']);

		if(activeIndex > -1) {
			checkedValueArr = [...checkedValueArr.slice(0,activeIndex),...checkedValueArr.slice(activeIndex + 1)];
			checkedTextArr = [...checkedTextArr.slice(0,activeIndex),...checkedTextArr.slice(activeIndex + 1)];
		}else{
			checkedValueArr.push(item.value);
			checkedTextArr.push(item.text);
		}
		this.activeBlock.texts = checkedTextArr.join(',');
		this.activeBlock.values = checkedValueArr.join(',');

		if(!this.isMultiple) {
			let singleValue = activeIndex > -1 ? { text: '', value: '' } : { text: item.text, value: item.value };
			this.props.onChange && this.props.onChange(singleValue);
	        return;
		}


		this.props.onChange({ text: this.activeBlock.texts, value: this.activeBlock.values });
	}

    getBlockList() {
		if(!Array.isArray(this.props.biz_data)) {
			return [];
		}

		this.count = 0;//记录第一排放几个blockitem
		let textRank = 0;//列数，一行最多放四个
		let list = [];//结果集
		for(let i = 0; i < this.props.biz_data.length; i++) {
			let item = this.props.biz_data[i];
			let classLen = '';
			if(item.text.length >= 11) {
				classLen = 'superlong';
				textRank = textRank + 4;
			}else if(item.text.length > 4 && item.text.length < 11) {
				classLen = 'long';
				textRank = textRank + 2;
			}else{
				classLen = 'short';
				textRank = textRank + 1;
			}

			if(textRank <= 4) {
				this.count++;
			};
			if(!this.isExpand && textRank > 4) {
				break;
			}

			list.push(
				<DataBlockItem  item={item}
								key={i}
								isActive={this.activeBlock.values.split(',').includes(item['value'])}
								classLen={classLen}
								handleToggleItem={this.handleToggleItem.bind(this, item)}
				/>
			);
		}

	return list;

    }

    dataBlockTouch() {
    	document.activeElement && document.activeElement.blur();
    }

	render() {
		return (
			<div className='input-form-item dataBlock' onTouchTap={this.dataBlockTouch.bind(this)}>
				<div className='dataBlockTitle'>
					<span className={'title'}>{this.props.label}</span>
					{(this.isExpand || this.props.biz_data.length > this.state.blockList.length) ? <Icon onTouchTap={this.handleToggleIconClass} icon='m-sys-arrowdown' className='icon-ex' /> : null}
				</div>
				<div  className='dataBlockList'>
					{this.state.blockList}
				</div>
			</div>
		);
	}

}

export default DataBlock;



// WEBPACK FOOTER //
// ./src/components/Field_Components/DataBlock/DataBlock.js